import { StyleSheet, Platform, Dimensions } from "react-native";

const { width, height } = Dimensions.get('window');

// Get device pixel ratio to detect high-DPI displays  
const pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

// Enhanced responsive breakpoints - specifically handles 13-inch 1440p displays
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
// Better handling for 13-inch 1440p displays with high pixel density
const isSmallDesktop = (width >= 1024 && width <= 1500) || 
                      (pixelRatio > 1.5 && width >= 1440 && width <= 2560);
const isLargeDesktop = width > 1500 && !(pixelRatio > 1.5 && width <= 2560);

const fontFamilies = {
	Bodoni72Smallcaps: "Bodoni72Smallcaps",
};

const maxViewHeight = "500vh";

const styles = StyleSheet.create({
	body: {
		flex: 1,
		position: "relative",
		backdropFilter: "blur(10px)",
		overflow: "auto",
		overflowX: "hidden",
		minHeight: "100vh",
		width: "100vw",
		maxWidth: "100vw",
	},
	container: {
		flex: 1,
		width: "100%",
		maxWidth: "100vw",
		overflowX: "hidden",
		position: "relative",
		alignItems: "center",
		minHeight: "100vh",
	},
	section: {
		flex: 1, // Each section takes up an equal portion of the screen's height
		minHeight: isMobile ? "auto" : "100vh",
		zIndex: 1,
		left: 0,
		right: 0,
		justifyContent: "center",
		alignContent: "center",
		paddingBottom: isMobile ? 100 : 125, // Less bottom padding on mobile
		paddingTop: 0,
		top: 0,
	},
	headerBar: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		paddingHorizontal: 100,
		paddingTop: 50,
		position: "relative",
		minWidth: "100vw",
		zIndex: 98,
	},
	logoArea: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		height: 62,
		marginTop: 10,
	},
	logoText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: 50,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	loginArea: {
		flex: 1,
		flexDirection: "row",
		backgroundColor: "transparent",
		maxHeight: 50,
	},
	loginButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	backButton: {
		position: "absolute",
		right: 200,
		width: "auto",
		height: 62,
		backgroundColor: "transparent",
		shadowOffset: { width: 7, height: 3 },
		shadowRadius: 6,
		shadowColor: "rgba(0, 0, 0, 0.04)",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonLeft: {
		position: "absolute",
		left: 200,
		width: "auto",
		height: 62,
		backgroundColor: "transparent",
		// shadowOffset: { width: 7, height: 3 },
		// shadowRadius: 6,
		// shadowColor: "rgba(0, 0, 0, 0.04)",
		alignItems: "left",
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonToRegistry: {
		position: "absolute",
		top: 20,
		left: isMobile ? -85 : isTablet ? -350 : isSmallDesktop ? -435 : -475,
		width: 40, // Set a fixed width for a rounded button
		height: 40, // Height remains the same to maintain a circular shape
		backgroundColor: "red", // Changed to red background
		borderRadius: 31, // Half of width/height to make it perfectly round
		alignItems: "center", // Center align the text inside the button
		justifyContent: "center",
		zIndex: 99,
	},
	backButtonText: {
		// fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 18 : 25,
		lineHeight: 30,
		textAlign: "center",
		color: "white", // Changed text color to white
	},
	loginButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		lineHeight: 30,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	cancelButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 25,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
		paddingRight: 90,
	},
	signOutButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: 25,
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	backgroundImage: {
		flex: 1,
		resizeMode: "cover",
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		width: "100%",
		height: "100%",
		minHeight: "100vh",
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundAttachment: "fixed",
		zIndex: 0,
	},
	welcomeText: {
		width: 1000,
		height: 127,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 90,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 30, height: 3 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.06)",
		textAlign: "center",
		alignSelf: "center", 
	},
	descriptionText: {
		width: 731,
		height: 199,
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: 45,
		lineHeight: 60,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		textAlign: "center", // Change this for horizontal centering
		alignSelf: "center", // Add this for vertical centering
	},
	pageHeader: {
		width: "100%",
		maxWidth: "none",
		marginHorizontal: "auto",
		flexDirection: isMobile || isTablet ? "column" : "row",
		justifyContent: "space-between",
		alignItems: isMobile || isTablet ? "center" : "flex-start",
		paddingHorizontal: isMobile ? 20 : isTablet ? 45 : isSmallDesktop ? 60 : 100,
		paddingVertical: isMobile ? 20 : isTablet ? 30 : 40,
		zIndex: 10,
	},
	header: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 28 : isTablet ? 35 : 45,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		paddingBottom: isMobile ? 15 : 25,
		marginTop: 0,
		textAlign: "center",
	},
	yearbookContainer: {
		width: isMobile || isTablet ? "100%" : "30%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingHorizontal: isMobile ? 10 : isTablet ? 20 : isSmallDesktop ? 10 : 15,
		paddingVertical: isMobile ? 20 : isTablet ? 20 : 0,
		marginBottom: isMobile || isTablet ? 30 : 0,
		minHeight: isMobile || isTablet ? "auto" : 400,
		alignSelf: isMobile || isTablet ? "center" : "center",
		marginHorizontal: isMobile || isTablet ? "auto" : 0,
	},
	shareContainer: {
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		marginTop: isMobile || isTablet ? 15 : 20,
		zIndex: 1000,
	},
	shareButton: {
		width: "100%",
		maxWidth: 300,
		height: isMobile ? 60 : isTablet ? 65 : 75,
		marginHorizontal: "auto",
	},
	goalTrackerContainer: {
		width: isMobile || isTablet ? "100%" : "30%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingHorizontal: isMobile ? 10 : isTablet ? 20 : isSmallDesktop ? 10 : 15,
		paddingVertical: isMobile ? 20 : isTablet ? 20 : 0,
		marginBottom: isMobile || isTablet ? 30 : 0,
		minHeight: isMobile || isTablet ? "auto" : 400,
		alignSelf: isMobile || isTablet ? "center" : "center",
		marginHorizontal: isMobile || isTablet ? "auto" : 0,
	},
	eventsButton: {
		backgroundColor: "#fefde2",
		width: isMobile ? 200 : isTablet ? 250 : 284,
		height: isMobile ? 45 : isTablet ? 50 : 55,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
		border: "none",
		cursor: "pointer",
		transition: 'all 1s ease',
	},
	eventsButtonHover: {
		backgroundColor: "#e6e5cb",
		transform: "scale(1.025)",
	},
	eventsButtonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 14 : isTablet ? 16 : 20,
		lineHeight: "1.2",
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		width: "70%",
	},
	profileContainer: {
		width: "100%",
		maxWidth: isMobile || isTablet ? 400 : "none",
		alignItems: "center",
		justifyContent: "center",
		paddingHorizontal: isMobile ? 15 : isTablet ? 25 : isSmallDesktop ? 35 : 40,
		paddingVertical: isMobile ? 20 : isTablet ? 30 : isSmallDesktop ? 40 : 50,
		marginBottom: isMobile || isTablet ? 30 : 0,
		borderRadius: 250,
		zIndex: 10,
	},
	profileImage: {
		width: isMobile ? 150 : isTablet ? 200 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 150 : isTablet ? 200 : isSmallDesktop ? 200 : 250,
		borderRadius: 250,
		marginBottom: isMobile ? 8 : isTablet ? 10 : 12,
		alignSelf: 'center',
		marginHorizontal: 'auto',
	},
	sealImage: {
		width: isMobile ? 50 : 75,
		height: isMobile ? 50 : 75,
		borderRadius: 60,
		marginTop: isMobile ? 50 : isTablet ? 25 : isSmallDesktop ? 25 : 25,
		marginRight: isMobile ? 100 : 175,
		position: "absolute",
	},
	welcomeText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: 90,
		paddingBottom: 25,
		paddingTop: 50,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
	},
	profileName: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 32 : isTablet ? 48 : isSmallDesktop ? 48 : 65,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	profileDetails: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 18 : isTablet ? 22 : isSmallDesktop ? 22 : 28,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	profileDetailsSmall: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		paddingTop: 2,
		color: "#e4e4e4",
		fontSize: isMobile ? 16 : isTablet ? 18 : isSmallDesktop ? 18 : 20,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
		alignSelf: "center",
		width: "100%",
	},
	// New responsive layout containers
	mobileTabletLayout: {
		width: "100%",
		flexDirection: "column",
		alignItems: "center",
		paddingHorizontal: isMobile ? 15 : 20,
		paddingVertical: 10,
	},
	desktopLayout: {
		width: "100%",
		maxWidth: "none",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "stretch",
		marginHorizontal: "auto",
		paddingHorizontal: isLargeDesktop ? 60 : 40,
		paddingTop: 0,
		minHeight: 500,
		gap: isLargeDesktop ? 60 : 40,
	},
	leftColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		minHeight: 400,
	},
	centerColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minHeight: 400,
	},
	rightColumn: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		minHeight: 400,
	},
	sectionTitle: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		color: "#e4e4e4",
		fontSize: isMobile ? 28 : isTablet ? 35 : isSmallDesktop ? 40 : 45,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.4)",
		textAlign: "center",
	},
	yearbookSection: {
		width: "100%",
		marginBottom: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	shareSection: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	goalSection: {
		width: "100%",
		marginBottom: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	announcementSection: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	buttonsContainer: {
		flexDirection: isMobile ? "column" : "row",
		maxWidth: isMobile ? 380 : isTablet ? 750 : isSmallDesktop ? 1000 : 1400,
		alignSelf: "center",
		marginTop: isMobile ? 18 : isTablet ? 18 : isSmallDesktop ? 30 : 50,
		flex: 1,
		position: "relative",
		zIndex: 5,
		justifyContent: "center",
		alignItems: isMobile ? "center" : "flex-start",
	},
	buttonArea: {
		marginHorizontal: isMobile ? 35 : isTablet ? 45 : 45,
		flexDirection: "column",
		justifyContent: "center",
		alignContent: "center",
		alignSelf: "center",
		zIndex: 1000,
		marginBottom: isMobile ? 18 : 0,
	},
	button: {
		width: 284,
		height: 55,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
		transition: 'transform 0.5s ease, background-color 0.5s ease',
	},
	buttonHover: {
		backgroundColor: "#3e7a58",
		transform: 'scale(1.025)',
	},
	buttonDescription: {
		width: 300,
		height: 96,
		paddingTop: 15,
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize: 18,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde1",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		alignSelf: "center", // Add this for vertical centering
	},
	editButton: {
		alignSelf: "flex-end",
		marginRight: "5%",
		marginTop: 20,
		paddingVertical: isMobile ? 12 : 14,
		paddingHorizontal: isMobile ? 16 : 20,
		borderRadius: isMobile ? 18 : 24,
		backgroundColor: "#4c956c",
		// Enhanced shadow system
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.3,
		shadowRadius: 8,
		elevation: 8,
		width: isMobile ? "45%" : "20%",
		minWidth: isMobile ? 120 : 160,
		maxWidth: isMobile ? 160 : 200,
		top: 100,
		position: Platform.OS === "web" ? "fixed" : "absolute",
		zIndex: 1000,
		// Modern enhancements
		border: "2px solid rgba(255, 255, 255, 0.2)",
		transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
		alignItems: "center",
		justifyContent: "center",
	},
	backgroundButton: {
		alignSelf: "flex-end", // Aligns the button to the right
		marginRight: "5%", // Adds spacing from the right edge of the screen
		marginTop: 20, // Adds spacing from the top
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		backgroundColor: "#4c956c", // A green background color
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		width: "20%",
		top: 160,
		position: Platform.OS === "web" ? "fixed" : "absolute",
		zIndex: 1000, // Ensure it stays above other elements
	},
	editButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 14 : isTablet ? 20 : isSmallDesktop ? 22 : 25,
		textAlign: "center",
		color: "#e4e4e4",
		textShadow: "3px 3px 6px rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
	},
	editControls: {
		position: "absolute", // Position absolutely to place over other content
		bottom: 0, // Align to the bottom of the parent
		left: 0, // Align to the left of the parent
		right: 0, // Align to the right of the parent
		height: 40,
		backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
		padding: 20, // Add some padding around the buttons
		flexDirection: "row", // Layout buttons in a row
		justifyContent: "center", // Center buttons horizontally
		alignItems: "center", // Center items vertically within the container
		justifyContent: "space-around",
		// @ts-ignore
		position: Platform.OS === "web" ? "fixed" : undefined,
	},
	previewStyle: {
		width: 100, // adjust size accordingly
		height: 50, // adjust size accordingly
	},
	prevText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 18,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 30, height: 3 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.06)",
		textAlign: "center", // Change this for horizontal centering
		alignSelf: "center", // Add this for vertical centering
	},
	addGridButton: {
		marginTop: 0, // Space above the button
		width: "100%", // Full width to center the button text
		alignItems: "center", // Center content horizontally in the container
	},
	addButton: {
		color: "white",
		fontSize: 30,
		textAlign: "center", // Center the '+' text horizontally
		bottom: -750,
		zIndex: 99,
	},

	savePopup: {
		position: "absolute",
		bottom: 20, // You can adjust this
		left: 0,
		right: 0,
		alignItems: "center",
	},
	savePopupText: {
		backgroundColor: "#4c956c", // Or any color you prefer
		color: "white",
		padding: 10,
		borderRadius: 5,
	},
	errorPopup: {
		position: "absolute",
		bottom: 20, // You can adjust this
		left: 0,
		right: 0,
		alignItems: "center",
		backgroundColor: "red", // Or any color you prefer
	},
	errorPopupText: {
		color: "white",
		padding: 10,
		borderRadius: 5,
	},
	// Styles for the widget placeholders within the EditablePage component
	widgetPlaceholder: {
		borderWidth: 2,
		borderColor: "#cccccc", // A light grey border color
		borderRadius: 10,
		padding: 20,
		marginBottom: 20, // Adds spacing between each widget placeholder
		alignItems: "center",
		justifyContent: "center",
	},
	// Text style for empty widget placeholders
	widgetPlaceholderText: {
		color: "#cccccc", // Light grey text color
		textAlign: "center",
	},
	// Style for the actual widgets when in non-edit mode
	widgetContainer: {
		// Style similar to widgetPlaceholder but without the border
		padding: 20,
		marginBottom: 20,
	},

	gridItem: {
		width: 400,
		height: 400,
		margin: 75,
		borderColor: "#cccccc",
		borderWidth: 2,
		borderRadius: 10,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	gridItemOccupied: {
		backgroundColor: "#f0f0f0",
		borderWidth: 1,
		borderColor: "#ccc",
	},
	deleteButton: {
		position: "absolute",
		top: isMobile ? 8 : 12,
		right: isMobile ? 8 : 12,
		backgroundColor: "#ff4444", // Softer red
		borderRadius: 8, // Rounded square instead of pill
		width: isMobile ? 32 : 50, 
		height: isMobile ? 32 : 36,
		alignItems: "center",
		justifyContent: "center",
		zIndex: 10,
		// Enhanced visual treatment
		boxShadow: "0 2px 8px rgba(255, 68, 68, 0.25)",
		border: "1px solid rgba(255, 255, 255, 0.2)",
		transition: "all 0.2s ease",
	},
	deleteButtonText: {
		color: "white",
		fontWeight: "600",
		fontSize: isMobile ? 10 : 12,
		fontFamily: "Orpheus Pro",
		letterSpacing: 0.3,
		textAlign: "center",
		textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
	},

	modalContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
		top: 0,
	},

	modalContent: {
		width: isMobile ? "95%" : isTablet ? "80%" : "70%",
		maxWidth: isMobile ? 350 : isTablet ? 400 : 450,
		minHeight: isMobile ? 200 : 250,
		maxHeight: isMobile ? "85vh" : "75vh",
		alignSelf: "center",
		backgroundColor: "#fefde2",
		borderRadius: isMobile ? 12 : 16,
		padding: isMobile ? 16 : isTablet ? 20 : 24,
		paddingTop: isMobile ? 20 : isTablet ? 24 : 28,
		paddingBottom: isMobile ? 20 : isTablet ? 24 : 28,
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.25,
		shadowRadius: 16,
		elevation: 8,
		justifyContent: "flex-start",
		alignItems: "center",
		overflow: "visible",
		boxSizing: "border-box",
		gap: isMobile ? 8 : isTablet ? 12 : 16,
	},
	catalogueModalContent: {
		width: isMobile ? "100%" : "95%",
		maxHeight: isMobile ? '100%' : '95vh',
		height: isMobile ? '100%' : 'auto',
		borderRadius: isMobile ? 0 : 20,
		alignSelf: "center",
		backgroundColor: "#fefde2",
		padding: 0,
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.15,
		shadowRadius: 24,
		elevation: 8,
		zIndex: 2000,
		border: isMobile ? "none" : "1px solid #e2e8f0",
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
	},
	catalogueContainer: {
		width: "100%",
		alignItems: "flex-start",
		top: 0,
		overflow: "auto",
		backgroundColor: "#fefde2",
		borderRadius: isMobile ? 0 : 12,
		padding: isMobile ? 8 : 12,
		paddingBottom: isMobile ? 24 : 12,
		marginTop: 0,
		flex: 1,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
	},
	modalSubText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: 25,
		textAlign: "center",
		color: "#4C956C", // Or any other color that fits your theme
		marginBottom: 15,
	},
	overlayBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0,0,0,0.7)", // translucent black
		backdropFilter: "blur(25px)", // Adjust the px value to control the amount of blur
		zIndex: 1,
		height: maxViewHeight,
	},
	modalToggleButton: {
		alignSelf: "flex-end",
		marginRight: "5%",
		marginTop: 10,
		paddingVertical: isMobile ? 14 : 18,
		paddingHorizontal: isMobile ? 18 : 24,
		borderRadius: isMobile ? 20 : 28,
		backgroundColor: "#4c956c",
		// Enhanced shadow system
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.3,
		shadowRadius: 8,
		elevation: 8,
		top: isMobile ? 10 : 20,
		width: isMobile ? "50%" : "20%",
		minWidth: isMobile ? 150 : 200,
		maxWidth: isMobile ? 200 : 240,
		zIndex: 1000,
		alignItems: 'center',
		justifyContent: 'center',
		// Modern styling enhancements
		border: "2px solid rgba(255, 255, 255, 0.2)",
		transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 6,
		marginVertical: 10,
	},
	itemText: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		color: "#333",
		textAlign: "center",
		marginVertical: 5,
	},
	imagePreview: {
		width: 100,
		height: 100,
		borderRadius: 50,
		marginVertical: 10,
	},
	input: {
		borderWidth: 1,
		borderColor: "#ddd",
		padding: 10,
		fontSize: 18,
		borderRadius: 6,
		marginVertical: 10,
	},
	gridContainer: {
		flex: 1,
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: "center",
		alignItems: "flex-start",
		paddingBottom: 250,
		paddingHorizontal: isMobile ? 20 : isTablet ? 45 : isSmallDesktop ? 60 : 100,
		top: 0,
		position: "relative",
		width: "100%",
		maxWidth: "100%",
		gap: isMobile ? 8 : 16,
		overflow: "hidden",
		overflowX: "hidden",
		overflowY: "auto",
		boxSizing: "border-box",
		minHeight: 0,
	},

	itemCard: {
		backgroundColor: "#fefde2",
		borderRadius: 14,
		marginVertical: isMobile ? 6 : 10,
		marginHorizontal: isMobile ? 6 : 10,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.1,
		shadowRadius: 10,
		elevation: 5,
		border: "1px solid rgba(0, 0, 0, 0.07)",
		alignItems: "flex-start",
		maxWidth: isMobile ? "47%" : "22%",
		minWidth: isMobile ? "140px" : "200px",
		width: isMobile ? "47%" : "auto",
		height: isMobile ? "auto" : "auto",
		minHeight: isMobile ? 220 : 300,
		maxHeight: isMobile ? "none" : "none",
		padding: isMobile ? 10 : 12,
		overflow: "hidden",
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		position: "relative",
		transition: "all 0.25s ease",
		":hover": {
			transform: "translateY(-3px)",
			shadowOpacity: 0.16,
			shadowRadius: 14,
			elevation: 8,
			borderColor: "rgba(76, 149, 108, 0.25)",
		},
	},

	itemImage: {
		width: "100%",
		height: isMobile ? 130 : 170,
		borderRadius: 10,
		marginBottom: isMobile ? 8 : 10,
		objectFit: "cover",
		border: "1px solid rgba(0, 0, 0, 0.05)",
		transition: "opacity 0.3s ease",
		backgroundColor: "#f4f3e0",
	},

	itemName: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 13 : 15,
		fontWeight: "600",
		color: "#2d2d2d",
		textAlign: "left",
		marginBottom: isMobile ? 4 : 6,
		lineHeight: isMobile ? 18 : 21,
		letterSpacing: 0.1,
		overflow: "hidden",
		maxWidth: "100%",
		width: "100%",
		boxSizing: "border-box",
		numberOfLines: 2,
		ellipsizeMode: "tail",
	},

	itemDescription: {
		display: "none",
	},

	itemPrice: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 13 : 14,
		fontWeight: "600",
		color: "#4c956c",
		textAlign: "left",
		marginTop: isMobile ? 3 : 4,
		marginBottom: isMobile ? 8 : 10,
		letterSpacing: 0.2,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		maxWidth: "100%",
		width: "100%",
		boxSizing: "border-box",
		numberOfLines: 1,
		ellipsizeMode: "tail",
	},

	itemBuyButton: {
		backgroundColor: "#4c956c",
		borderRadius: 8,
		paddingVertical: isMobile ? 7 : 9,
		paddingHorizontal: 12,
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		marginTop: "auto",
		marginTop: isMobile ? 6 : 8,
	},

	itemBuyButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 13 : 14,
		fontWeight: "600",
		color: "#fefde2",
		letterSpacing: 0.3,
	},

	addButton: {
		backgroundColor: "blue",
		padding: 10,
		margin: 20,
		borderRadius: 5,
		alignSelf: "center",
	},

	itemSelected: {
		backgroundColor: "#4c956c", // Change as needed
	},
	modalContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
	},
	blurred: {
		position: "absolute",
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		backdropFilter: "blur(10px)", // Apply blur effect
		// backgroundColor: "rgba(0, 0, 0, 0.5)",
	},
	blurredContainer: {
		position: "fixed",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)",
		zIndex: 200000,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden',
	},
	modalText: {
		fontSize: 18,
	},
	confirmButton: {
		backgroundColor: '#4c956c',
		padding: isMobile ? 10 : isTablet ? 11 : 12,
		borderRadius: isMobile ? 8 : 10,
		marginVertical: isMobile ? 4 : 6,
		marginTop: isMobile ? 10 : isTablet ? 14 : 16,
		width: '90%',
		maxWidth: isMobile ? 250 : isTablet ? 265 : 280,
		minHeight: isMobile ? 40 : isTablet ? 44 : 46,
		alignItems: 'center',
		justifyContent: 'center',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 4,
		elevation: 3,
		alignSelf: 'center',
	},
	denyButton: {
		backgroundColor: '#dc3545',
		padding: isMobile ? 12 : 15,
		borderRadius: 12,
		marginVertical: 8,
		width: '85%',
		maxWidth: 300,
		minHeight: isMobile ? 44 : 48,
		alignItems: 'center',
		justifyContent: 'center',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 4,
		elevation: 3,
	},
	anonymousButton: {
		backgroundColor: 'rgba(76, 149, 108, 0.1)',
		padding: isMobile ? 8 : 10,
		borderRadius: 8,
		marginVertical: 4,
		width: '90%',
		maxWidth: 280,
		minHeight: isMobile ? 36 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		border: '1px solid rgba(76, 149, 108, 0.4)',
		alignSelf: 'center',
	},
	disabledButton: {
		backgroundColor: '#cccccc', // Grey background for disabled state
		opacity: 0.6,
	},
	buttonText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
	errorText: {
		color: 'red',
		fontSize: 14,
		marginBottom: 10,
		textAlign: 'center',
		fontFamily: 'Orpheus Pro',
	},
	modalSubText: {
		color: '#666',
		fontSize: 12,
		textAlign: 'center',
		fontFamily: 'Orpheus Pro',
		lineHeight: 16,
	},
	purchasedItem: {
		backgroundColor: '#f0f0f0',
		color: '#666666',
		borderRadius: 14,
		padding: isMobile ? 10 : 12,
		marginVertical: isMobile ? 6 : 10,
		marginHorizontal: isMobile ? 6 : 10,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.07,
		shadowRadius: 6,
		elevation: 2,
		border: "1px solid rgba(0, 0, 0, 0.05)",
		alignItems: "flex-start",
		maxWidth: isMobile ? "47%" : "22%",
		minWidth: isMobile ? "140px" : "200px",
		width: isMobile ? "47%" : "auto",
		height: isMobile ? "auto" : "auto",
		minHeight: isMobile ? 220 : 300,
		maxHeight: isMobile ? "none" : "none",
		overflow: "hidden",
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		position: "relative",
		opacity: 0.7,
		filter: "grayscale(0.3)",
		transition: "all 0.3s ease",
		"::after": {
			content: '"\'',
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: "rgba(76, 149, 108, 0.1)",
			pointerEvents: "none",
		},
	},
	purchasedLabel: {
		// Modern badge design for purchased label
		fontWeight: '600',
		color: '#ffffff', // White text on colored background
		fontSize: isMobile ? 12 : 14, // Slightly smaller for better proportions
		fontFamily: "Orpheus Pro",
		position: "absolute",
		top: isMobile ? 12 : 16,
		left: isMobile ? 12 : 16,
		backgroundColor: "#4c956c", // Use theme green instead of red
		paddingHorizontal: 12,
		paddingVertical: 6,
		borderRadius: 20, // Pill-shaped badge
		zIndex: 5,
		letterSpacing: 0.5,
		textTransform: "uppercase",
		// Enhanced shadow for the badge
		boxShadow: "0 2px 8px rgba(76, 149, 108, 0.3)",
		border: "2px solid rgba(255, 255, 255, 0.3)",
		// Overflow protection
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		maxWidth: "70%",
		boxSizing: "border-box",
		numberOfLines: 1,
		ellipsizeMode: "tail",
		// Subtle animation
		transition: "all 0.3s ease",
	},
	modalContainer: {
		backgroundColor: '#fefde2',
		borderRadius: 10,
		padding: 20,
		width: '80%',
		maxWidth: 400,
		alignItems: 'center',
	},
	modalContent: {
		alignItems: 'center',
	},
	modalTitle: {
		fontSize: isMobile ? 15 : isTablet ? 17 : 18,
		fontWeight: '600',
		marginBottom: isMobile ? 8 : isTablet ? 10 : 12,
		fontFamily: "Orpheus Pro",
		color: "#4c956c",
		textAlign: "center",
		lineHeight: isMobile ? 21 : isTablet ? 24 : 26,
		maxWidth: "100%",
		width: "100%",
		wordWrap: "break-word",
		whiteSpace: "normal",
		paddingHorizontal: 0,
		flexShrink: 1,
		flexWrap: "wrap",
	},
	catalogueModalTitle: {
		fontSize: isMobile ? 18 : 24,
		fontWeight: '600',
		marginTop: 0,
		marginBottom: 0,
		fontFamily: "system-ui, -apple-system, sans-serif",
		color: "#1e293b",
		flex: 1,
		textAlign: 'center',
		letterSpacing: '-0.025em',
	},
	fixedContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: 1000,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	catalogueItem: {
		transition: 'transform 0.3s ease',
	},
	catalogueItemHover: {
		transform: 'scale(1.05)',
	},
	categoryContainer: {
		transition: 'transform 0.3s ease',
	},
	categoryContainerHover: {
		transform: 'scale(1.05)',
	},
	continueButton: {
		backgroundColor: '#4c956c',
		padding: isMobile ? 12 : 15,
		borderRadius: 12,
		marginVertical: 8,
		width: '85%',
		maxWidth: 300,
		minHeight: isMobile ? 44 : 48,
		alignItems: 'center',
		justifyContent: 'center',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 4,
		elevation: 3,
	},
	buttonText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
	catalogueModalHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		position: 'relative',
		paddingVertical: isMobile ? 12 : 16,
		paddingHorizontal: isMobile ? 16 : 20,
		backgroundColor: "#fefde2",
		borderBottomWidth: 1,
		borderBottomColor: '#e2e8f0',
		flexShrink: 0,
	},

	catalogueCloseButton: {
		position: 'absolute',
		left: isMobile ? 12 : 16,
		top: '50%',
		transform: [{translateY: -20}],
		zIndex: 10,
		padding: isMobile ? 8 : 10,
		backgroundColor: '#dc2626',
		borderRadius: 50,
		width: isMobile ? 36 : 40,
		height: isMobile ? 36 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		border: 'none',
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		shadowColor: '#000000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.2,
		shadowRadius: 4,
		elevation: 4,
	},
	// Responsive Desktop Layout Styles
	desktopContainer: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		maxWidth: '100%',
		overflow: 'hidden',
		marginTop: 20,
	},
	titlesRow: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: isMobile ? 10 : isTablet ? 8 : 5
	},
	componentsRow: {
		display: 'flex',
		flexDirection: isMobile || isTablet ? 'column' : 'row',
		width: '100%',
		justifyContent: 'space-evenly',
		alignItems: isMobile || isTablet ? 'center' : 'flex-start',
		// Allow row to expand vertically when children grow
		height: 'auto',
		minHeight: isMobile || isTablet ? 'auto' : 700,
		maxHeight: 'none',
		overflow: 'visible'
	},
	columnContainer: {
		flex: 1,
		flexDirection: 'column',
		alignItems: 'center',
		// Allow height to grow dynamically on desktop
		height: isMobile || isTablet ? 'auto' : 'fit-content',
		minHeight: isMobile || isTablet ? 'auto' : 650,
		maxHeight: 'none',
		overflow: 'visible',
	},
	profileColumnContainer: {
		// Allow dynamic height to match other columns
		height: isMobile || isTablet ? 'auto' : 'fit-content',
		minHeight: isMobile || isTablet ? 'auto' : 700,
		maxHeight: 'none',
		flex: 1,
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: isMobile || isTablet ? 'flex-start' : 'center',
		overflow: 'visible'
	},
	widgetContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		overflow: 'visible'
	},

	purchaseModalInput: {
		borderWidth: 1,
		borderColor: "#4c956c",
		padding: isMobile ? 12 : 14,
		fontSize: isMobile ? 14 : 16,
		borderRadius: 8,
		marginVertical: 6,
		width: "100%",
		maxWidth: 300,
		minHeight: isMobile ? 44 : 48,
		backgroundColor: "white",
		fontFamily: "Orpheus Pro",
		boxSizing: "border-box",
		textAlign: "center",
	},

	modalTextContainer: {
		maxWidth: "100%",
		width: "100%",
		paddingVertical: 0,
		paddingHorizontal: 0,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		flexWrap: "wrap",
		gap: isMobile ? 8 : 12,
		flexShrink: 1,
	},

	// Improved anonymous button text
	anonymousButtonText: {
		color: '#4c956c',
		fontSize: isMobile ? 12 : 14,
		fontWeight: '500',
		textAlign: "center",
		lineHeight: isMobile ? 16 : 18,
		wordWrap: "break-word",
		whiteSpace: "normal",
		paddingHorizontal: 8,
		opacity: 0.8,
	},

	// Modal question title (smaller than main modal title)
	modalQuestionTitle: {
		fontSize: isMobile ? 18 : isTablet ? 20 : 22,
		fontWeight: '600',
		marginBottom: isMobile ? 12 : isTablet ? 14 : 16,
		fontFamily: "Orpheus Pro",
		color: "#2d2d2d", // Darker for better hierarchy
		textAlign: "center",
		lineHeight: isMobile ? 24 : isTablet ? 26 : 28,
		maxWidth: "100%",
		width: "100%",
		wordWrap: "break-word",
		whiteSpace: "normal",
		paddingHorizontal: 0,
		flexShrink: 1,
		flexWrap: "wrap",
	},

	// Modal item display name (different from registry itemName)
	modalDisplayItemName: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 14 : isTablet ? 16 : 18,
		fontWeight: "400",
		color: "#666666", // Gray for secondary text
		textAlign: "center",
		marginBottom: isMobile ? 16 : isTablet ? 18 : 20,
		marginTop: isMobile ? 8 : 10,
		lineHeight: isMobile ? 18 : isTablet ? 22 : 24,
		letterSpacing: 0.1,
		overflow: "visible",
		whiteSpace: "normal",
		wordWrap: "break-word",
		maxWidth: "100%",
		width: "100%",
		flexShrink: 1,
	},

	// Supporting text (like "Please provide at least one contact method")
	modalSupportText: {
		fontSize: isMobile ? 12 : isTablet ? 13 : 14,
		lineHeight: isMobile ? 16 : isTablet ? 18 : 20,
		textAlign: "center",
		color: "#666666", // Gray for less important text
		fontFamily: "Orpheus Pro",
		marginVertical: isMobile ? 6 : 8,
		paddingHorizontal: isMobile ? 4 : 8,
		maxWidth: "100%",
		width: "100%",
		wordWrap: "break-word",
		whiteSpace: "normal",
		flexShrink: 1,
		flexWrap: "wrap",
		fontStyle: "italic",
	},

	// Saved user information display
	savedInfoContainer: {
		backgroundColor: "rgba(76, 149, 108, 0.08)",
		borderRadius: 8,
		padding: isMobile ? 12 : 16,
		marginVertical: isMobile ? 8 : 12,
		width: "100%",
		maxWidth: "100%",
		border: "1px solid rgba(76, 149, 108, 0.2)",
	},

	savedInfoText: {
		fontSize: isMobile ? 12 : 14,
		fontWeight: "600",
		color: "#4c956c",
		fontFamily: "Orpheus Pro",
		textAlign: "center",
		marginBottom: 6,
	},

	savedInfoDetail: {
		fontSize: isMobile ? 11 : 12,
		color: "#333333",
		fontFamily: "Orpheus Pro",
		textAlign: "center",
		marginVertical: 1,
		lineHeight: isMobile ? 14 : 16,
	},
});

export default styles;
